import React from 'react';

import { Alert, Typography } from 'antd';

import { useGetSunBetaModules } from 'v2/hooks/useGetSunBetaModules';

const SUN_BETA_MODULE_INSTALLMENT_2_0 = 'installment_2_0';

type InstallmentCashbackAlertProps = {
  enabled: boolean;
};

function InstallmentCashbackAlert({ enabled }: InstallmentCashbackAlertProps) {
  const { data: sunBetaModules } = useGetSunBetaModules(enabled);

  if (!sunBetaModules?.includes(SUN_BETA_MODULE_INSTALLMENT_2_0)) {
    return null;
  }

  return (
    <Alert
      showIcon
      type='warning'
      message={
        <Typography.Text>
          <Typography.Text strong>Importante:</Typography.Text> a tarifa de antecipação não incide sobre o Cashback do
          parcelamento. A tarifa é calculada somente sobre o ganho líquido da fatura.
        </Typography.Text>
      }
    />
  );
}

export default InstallmentCashbackAlert;
